































































































import { Component, Emit, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { DataTable, Col } from '@/components/molecules/DataTable'
import { BibliographyClass, CollectionFlag, Prefix, SearchType } from '@/types'
import { IconBibliography } from '@/components/molecules/IconBibliography'

export interface SelectReserveTypeTableItem {
  isSelected: boolean
  id: number
  rank: number
  bibliographyRealId: number
  bibliographyClass: BibliographyClass
  prefix: Prefix
  searchType: SearchType
  displayTitle: string
  displayAuthor: string
  displayPublisher: string
  displayPublished: string
  displaySize: string
  collectionFlag: CollectionFlag
  shelfCount: number
}

@Component({
  components: { IconBibliography, DataTable }
})
export default class SelectReserveTypeTable extends ComponentVue {
  @Prop({
    type: Array,
    required: true
  })
  items!: SelectReserveTypeTableItem[]

  @Prop({
    type: Number,
    required: true
  })
  height!: number

  @Prop({
    type: Boolean,
    default: false
  })
  rank!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  checkBox!: boolean

  @Prop({
    type: Boolean,
    required: true
  })
  isAllSelect!: boolean

  @Prop({
    type: Number,
    required: true
  })
  disabledCheckBoxIndex!: number

  get cols(): Col[] {
    const cols: Col[] = [
      {
        width: 50,
        items: [
          {
            name: 'no',
            headerText: this.rank ? '順位' : '',
            align: 'right'
          }
        ]
      },
      {
        width: '14',
        resizable: true,
        items: [
          {
            name: 'bibliographyRealId',
            headerText: '書誌番号'
          }
        ]
      },
      {
        width: '33',
        resizable: true,
        items: [
          {
            name: 'displayTitle',
            headerText: 'タイトル'
          }
        ]
      },
      {
        width: '11',
        resizable: true,
        items: [
          {
            name: 'displayAuthor',
            headerText: '責任表示'
          }
        ]
      },
      {
        width: '11',
        resizable: true,
        items: [
          {
            name: 'displayPublisher',
            headerText: '出版者'
          }
        ]
      },
      {
        width: '11',
        resizable: true,
        items: [
          {
            name: 'displaySize',
            headerText: '大きさ'
          }
        ]
      },
      {
        width: '11',
        resizable: true,
        items: [
          {
            name: 'displayPublished',
            headerText: '出版年'
          }
        ]
      },
      {
        width: '9',
        resizable: true,
        items: [
          {
            name: 'shelfCount',
            headerText: '予受可資料'
          }
        ]
      }
    ]

    if (this.checkBox) {
      cols.unshift({
        width: 26,
        items: [
          {
            name: 'check',
            align: 'center'
          }
        ]
      })
    }

    if (this.rank) {
      cols.push({
        width: 140,
        items: [
          {
            name: 'rank',
            align: 'center'
          }
        ]
      })
    }

    return cols
  }

  bibliographyId(item: SelectReserveTypeTableItem) {
    if (item.bibliographyRealId === 0) {
      return ''
    }

    return item.prefix + item.bibliographyRealId.toString().padStart(10, '0')
  }

  isCollectionFlagCollection(collectionFlag: CollectionFlag): boolean {
    return collectionFlag === CollectionFlag.Collection
  }

  movableUp(value: SelectReserveTypeTableItem): boolean {
    const index = this.items.findIndex(
      item => item.bibliographyRealId === value.bibliographyRealId
    )

    return index !== 0
  }

  movableDown(value: SelectReserveTypeTableItem): boolean {
    const index = this.items.findIndex(
      item => item.bibliographyRealId === value.bibliographyRealId
    )

    return index !== this.items.length - 1
  }

  onClickUp(index: number) {
    this.items.splice(index - 1, 2, this.items[index], this.items[index - 1])
  }

  onClickDown(index: number) {
    this.items.splice(index, 2, this.items[index + 1], this.items[index])
  }

  @Emit('click:row')
  onClickRow(index: number): number {
    return index
  }

  @Emit('all-select')
  onAllSelect(): void {}
}
